export default __webpack_public_path__ + "static/media/worldmap.6f780998.svg";